import styled from "styled-components";
import { css } from "styled-components";
import { devices } from "../../Devices";
import { Input } from "../sharable/InputStyle";

export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
`;

export const CompactHeader = styled.header`
  display: flex;
  justify-content: center;
  padding: 1.6rem 2.4rem;
  margin-bottom: 1.6rem;
  @media ${devices.tablet} {
    justify-content: flex-start;
  }
`;

export const CenteredArea = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 42rem;
  background-color: #fff;
  border: 1px solid rgba(1, 1, 1, 0.08);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(1, 1, 1, 0.08);
  padding: 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  position: relative;

  @media ${devices.mobileL} {
    padding: 2rem 1.6rem;
    border-radius: 12px;
  }
`;

export const FormCardHeader = styled.div`
  text-align: center;

  h1 {
    font-size: 2rem;
    font-weight: 800;
    text-transform: uppercase;
  }

  p {
    font-size: 1.3rem;
    color: #555;
    margin-top: 0.4rem;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  label {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: 4.8rem;
  font-size: 1.5rem;

  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: #b91c1c;
    `}
`;

export const PasswordFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
`;

export const ForgotPasswordLink = styled.div`
  text-align: right;
  font-size: 1.2rem;

  a {
    color: #d97706;
    transition: opacity 300ms ease-in-out;
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #999;
  font-size: 1.2rem;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: rgba(1, 1, 1, 0.1);
  }
`;

export const FooterNote = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: #999;
  padding-bottom: 1.6rem;
`;
